<template>
  <div class="flex flex-col">
    <div class="p-2 bg-gray-50 rounded-md">
      <div v-if="wait">
        <Spinner
          message="Loading..."
          :size="6"
        />
      </div>
      <div v-else>
        <div class="p-2 bg-gray-50 rounded-md">
          <div class="flex flex-col">
            <div class="grid grid-cols-2 gap-2 bg-gray-100 p-2 rounded-md shadow-md"
              v-for="statusObject in statusObjectsList"
              :key="statusObject.type">
              <div class="flex flex-row gap-2 items-center shadow-md rounded-md">
                <div class="p-2 font-italics text-gray-400">
                  {{ statusObject.display.dataType }}
                </div>
                <div class="p-2 font-bold">
                  {{ getClearingStatusDisplay(statusObject.type, statusObject.id) }}
                </div>
              </div>
              <div class="flex flex-row justify-end gap-2">
                <Button
                  color="blue"
                  size="md"
                  @click="addItemToRoutePulling(statusObject)">
                  {{ statusObject.display.addItem }}
                </Button>
                <Button
                  color="blue"
                  size="md"
                  @click="removeItemFromRoutePulling(statusObject)">
                  {{ statusObject.display.removeItem }}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reduce, find } from 'lodash'

import Button from '../../Button.vue'
import Spinner from '../../Spinner.vue'

// import user from '../../../services/user/user.js'

export default {
  components: {
    Button,
    Spinner,
  },
  props: {
    statusObjects: Object,
    routePullDataArray: Array,
    wait: Boolean,
  },
  data() {
    return {}
  },
  methods: {
    init() {
      // await user.ready()
    },
    dataTypeDisplayMessage(type) {
      switch (type) {
        case 'schedule_request':
          return 'Current Request'
        default:
          return '---'
      }
    },
    addItemDisplayMessage(type) {
      switch (type) {
        case 'schedule_request':
          return 'Add Future Schedule'
        default:
          return 'Add Item'
      }
    },
    removeItemDisplayMessage(type) {
      switch (type) {
        case 'schedule_request':
          return 'Remove Future Schedule'
        default:
          return 'Remove Item'
      }
    },
    getClearingStatusDisplay(objectType, objectId) {
      if (!(this.clearingStatusData && this.clearingStatusData[objectType])) {
        return 'Not In Route Pull'
      }
      let status = this.clearingStatusData[objectType][objectId]
      switch (status) {
        case 'pending':
          return 'Pending Route Pull'
        default:
          return 'Not In Route Pull'
      }
    },
    addItemToRoutePulling(statusObject) {
      this.$emit('addItem', statusObject)
    },
    removeItemFromRoutePulling(statusObject) {
      this.$emit('removeItem', statusObject)
    },
  },
  computed: {
    statusObjectsList() {
      return reduce(this.statusObjects, (result, value, key) => {
        result.push({
          type: key,
          id: value['id'],
          display: {
            dataType: this.dataTypeDisplayMessage(key),
            addItem: this.addItemDisplayMessage(key),
            removeItem: this.removeItemDisplayMessage(key),
          },
        })
        return result
      }, [])
    },
    clearingStatusData() {
      let retVal = {}
      for (const statusObject of this.statusObjectsList) {
        console.log(statusObject)
        if (retVal[statusObject.type] === undefined) {
          retVal[statusObject.type] = {}
        }
        let routePullDataItem = find(this.routePullDataArray, (item) => statusObject.type === item?.type && statusObject.id === item?.data_id)

        if (routePullDataItem) {
          retVal[statusObject.type][statusObject.id] = routePullDataItem.status
        }
      }
      return retVal
    },
  },
  mounted() {
    if (this.wait) {
      return
    }

    this.init()
  },
  watch: {
    wait(newValue) {
      if (!newValue) {
        this.init()
      }
    },
  },
}
</script>
